import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { Group } from "@interfaces/group.interface";
import { LogExport } from "@interfaces/logExport.interface";
import { ExportLogService } from "@services/exportLog.service";
import { GroupService } from "@services/group.service";
import { ProtectedGridService } from "@services/protectedGrid.service";
import { ToastService } from "angular-toastify";

@Component({
	moduleId: module.id,
	selector: "groups",
	styleUrls: ["groups.css"],
	templateUrl: "groups.html"
})
export class GroupsAdminComponent {
	canExportGrid = false;
	groups: Group[] = [];
	headerPrimaryButtons: AdminHeaderButton[] = [];
	itemUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	title = "Groups";

	constructor(private toastService: ToastService, private exportLogService: ExportLogService, private groupService: GroupService, private protectedGridService: ProtectedGridService, private router: Router) {
		this.getGroups();
		this.checkGridExportPermissions();

		this.viewRow = this.viewRow.bind(this);
	}
	
	checkGridExportPermissions() {
		this.protectedGridService.canExport("Groups")
			.subscribe(
				(res: any) => {
					this.canExportGrid = res.response;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	getGroups() {
		this.groupService.getAll()
			.subscribe(
				(res: any) => this.groups = res.response.items,
				(err) => console.log(err),
			);
	}

	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}

	logExport() {
		const logExport = new LogExport();
		logExport.gridName = "Groups";
		this.exportLogService.logExport(logExport)
			.subscribe(
				() => console.log("Export Logged"),
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
					return false;
				},
			);
	}

	viewRow(e: any) {
		this.router.navigate([`${this.itemUrl}/${e.row.data.id}`]);
	}
}